/**
 * Account-level gate for hiding every "Upload Creatives" entry point in the UI:
 * the Creative Manager page CTA, the campaign-detail upload buttons
 * (CampaignCompletionStatus / CampaignActivity), and the
 * "Upload Creatives to <platform>" chat dropdown items.
 *
 * Opt-in per account via the `hide-upload-creatives` account setting
 * (boolean-string convention, same as `enable-v3-ui`). Absent or any value
 * other than 'true' keeps the buttons visible, so existing accounts are
 * unaffected.
 */
export const HIDE_UPLOAD_CREATIVES_KEY = 'hide-upload-creatives';

export function isUploadCreativesHidden(accountSettings) {
  return accountSettings?.[HIDE_UPLOAD_CREATIVES_KEY] === 'true';
}
